import type { CloseLoopPlaceholder } from "./close-loop-template"
import { formatThreadNumber } from "./thread-number"

export const AUTO_REPLY_PLACEHOLDERS: CloseLoopPlaceholder[] = [
	{ key: "OfficeHours", label: "Your office hours" },
	{ key: "TicketNumber", label: "Ticket number" },
]

// Also takes {{office_hours}} and inner spaces, since people type it by hand.
const OFFICE_HOURS_TOKEN = /\{\{\s*office[_ ]?hours\s*\}\}/gi
const TICKET_NUMBER_TOKEN = /\{\{\s*ticket[_ ]?number\s*\}\}/gi

const escapeHtml = (text: string) =>
	text
		.replaceAll("&", "&amp;")
		.replaceAll("<", "&lt;")
		.replaceAll(">", "&gt;")
		.replaceAll('"', "&quot;")

export const fillAutoReplyTemplate = (
	html: string,
	{
		officeHours,
		ticketNumber,
	}: { officeHours: string; ticketNumber?: number | null },
): string => {
	const hours = escapeHtml(officeHours.trim())
	const number = formatThreadNumber(ticketNumber)
	return html
		.replace(OFFICE_HOURS_TOKEN, () => hours)
		.replace(TICKET_NUMBER_TOKEN, () => number)
}
